import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../contexts/EncoreContext";
import { Experimental__IconUserActive } from "../../Experimental__Icon/icons/Experimental__IconUserActive";
import { Icon } from "../";
export function IconUserActive(props) {
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);

  if (status !== encoreContextStatus.deprecated) {
    return /*#__PURE__*/React.createElement(Experimental__IconUserActive, props);
  }

  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<path d=\"M20.5 21.47a5.53 5.53 0 00-.65-2.94A5 5 0 0018 16.7l-3.14-1.8a1 1 0 01-.32-1.63l.53-.56.13-.13A5.72 5.72 0 0017 8.51 5.27 5.27 0 0012 3a5.27 5.27 0 00-5 5.51 5.72 5.72 0 001.83 4.06l.13.13.53.56a1 1 0 01-.32 1.63L6 16.7a5 5 0 00-1.87 1.84 5.53 5.53 0 00-.65 2.94z\" fill=\"#181818\" stroke=\"#181818\"/>"
    }
  }));
}
export default IconUserActive;